import type { Group, TeamsMeeting, User } from '@ms/yammer-data/dist/state/types';

import type { GetBaseUrlProps } from '../location/getBaseUrl';
import { getBaseUrl } from '../location/getBaseUrl';

type AskMeAnythingPage = (teamsMeetingId: TeamsMeeting['id']) => string;
export const amaPageBasePath = '/ama';
export const askMeAnythingPagePathname: AskMeAnythingPage = (teamsMeetingId) => `/ama/${teamsMeetingId}`;

export const askMeAnythingPageInReviewConversations: AskMeAnythingPage = (teamsMeetingId) =>
  `/ama/${teamsMeetingId}/in-review`;

export const askMeAnythingPageDismissedConversations: AskMeAnythingPage = (teamsMeetingId) =>
  `/ama/${teamsMeetingId}/dismissed`;

export const askMeAnythingPagePublishedConversations: AskMeAnythingPage = (teamsMeetingId) =>
  `/ama/${teamsMeetingId}/published`;

export const askMeAnythingPageInsights: AskMeAnythingPage = (teamsMeetingId) => `/ama/${teamsMeetingId}/insights`;

type AskMeAnythingPageUrl = (
  teamsMeetingId: TeamsMeeting['id'],
  host: GetBaseUrlProps['host'],
  currentNetworkContext: GetBaseUrlProps['currentNetworkContext']
) => string;
export const askMeAnythingPageUrl: AskMeAnythingPageUrl = (teamsMeetingId, host, currentNetworkContext) => {
  const baseUrl = getBaseUrl({ currentNetworkContext, host });

  return `${baseUrl}${askMeAnythingPagePathname(teamsMeetingId)}`;
};

export const askMeAnythingPageMatchPath = '/ama/:teamsMeetingId';

type AskMeAnythingEventsPage = (userId: User['id']) => string;
export const askMeAnythingEventsPage: AskMeAnythingEventsPage = (userId) => `/users/${userId}/events/askmeanything`;

type AskMeAnythingEventCreationPage = (userId?: User['id']) => string;
export const askMeAnythingEventCreationPage: AskMeAnythingEventCreationPage = (userId) => {
  const path = '/ama/new';

  return userId ? `${path}/${userId}` : path;
};

type AskMeAnythingEventCreationPageGroup = (groupId?: Group['id']) => string;
export const askMeAnythingEventCreationPageGroup: AskMeAnythingEventCreationPageGroup = (groupId) => {
  const path = '/ama/new';

  return groupId ? `${path}/group/${groupId}` : path;
};

type AskMeAnythingEventCreationPageFrom = (from?: string) => string;
export const askMeAnythingEventCreationPageFrom: AskMeAnythingEventCreationPageFrom = (from) => {
  const path = '/ama/new';

  return from ? `${path}?${new URLSearchParams({ from }).toString()}` : path;
};

type AskMeAnythingEventEditingPage = (teamsMeetingId: TeamsMeeting['id']) => string;
export const askMeAnythingEventEditingPage: AskMeAnythingEventEditingPage = (teamsMeetingId) =>
  `/ama/${teamsMeetingId}/edit`;

type AskMeAnythingRedirectPage = (teamsMeetingId: TeamsMeeting['id']) => string;
export const askMeAnythingRedirectPage: AskMeAnythingRedirectPage = (teamsMeetingId) =>
  `/ama/redirect/${teamsMeetingId}`;
